import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { ApiLoginService } from './api-login.service';
// import { DetailUser } from '../model/detailUser';
// import { CategoryNode } from '../model/categoryNode';
// import { Address } from '../model/address';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json'
//   })
// };

// const httpOptionstoken = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json',
//     // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
//     // 'Authorization' : "Bearer iUNN190UlfG5fKGzV5pHsIWrEELDfJ7a"
//     // 'Authorization' : "Bearer MSzNT2Jk-mILyGIVk9lcjxHUc2HKfi1L"
//   })
// };
@Injectable({
  providedIn: 'root'
})
 
export class ApiContentService {

	// private urlApi = 'http://localhost:8000/';
  // public urlApi = 'http://coremanagement-dev.mncplaymedia.com/core-backend/public/';
  // public urlApi = 'http://localhost/sgsbackend/frontend/web/index.php/';
  // public urlApi = 'http://localhost/apiopencontent/frontend/web/index.php/'; 
  // public urlApivalsys = 'http://localhost/valsys/frontend/web/index.php/';
  // public urlApi = 'http://10.9.26.169/sgsapi/frontend/web/index.php/';
  //public urlApi = 'http://sgs-api-dev.mncplaymedia.com/frontend/web/index.php/';
  // public urlApi = 'http://localhost/sgsapi/frontend/web/index.php/'; //local
  // public urlApi = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/'; //dev_public
  public urlApi = 'https://sgs-api.mncplay.id/frontend/web/index.php/'; //prod_public
  // public urlApiImage = 'http://localhost/sgsapi/frontend/web/index.php/';
  // public urlApiImage = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/'; //dev_public
  public urlApiImage = 'https://sgs-api.mncplay.id/frontend/web/index.php/'; //prod_public


  // public urlApilocation = "https://eu1.locationiq.com/v1/search.php?key=1d5dbcfc514ea6&format=json"

  constructor(
    private http: HttpClient,
    private apilogin: ApiLoginService,
  ) { }

  _httpOptions(){
    
    const currentUser:any = this.apilogin.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.data.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 
  
  _httpOptionsparams(params:any){
    
    const currentUser:any = JSON.parse(localStorage.getItem('currentUser'));;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.data.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
            params: params
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  
  /* start test Api */
  // setCreateporspect(params: any){
  //     // console.log( JSON.stringify(getFormEditCategory));
  //     return this.http.post<any>(this.urlApivalsys + 'valsys/entryprospects/createprospect', (params), this._httpOptions());
  // }

  setUpload(params: any){
      // console.log( JSON.stringify(getFormEditCategory));
      
      return this.http.post<any>(this.urlApi + 'opencontent/orders/upload', (params), this._httpOptions());
  }
  /* end test Api */

  /* Account */
  checkAccount(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/accounts/checkaccountid/' + params.accountid, (params), this._httpOptions());
  }
  checkProspek(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/checkprospekid/' + params.prospekindex, (params), this._httpOptions());
  }
  /* End Account */

  /* Regis */
  checkLatlon(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/checklatlon', (params), this._httpOptions());
  }
  
  setDataprospek(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/coveragecheck', (params), this._httpOptions());
  }
  
  setOtpprospek(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/setotp/'+params.prospekindex, (params), this._httpOptions());
  }
  
  sendSmsotp(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/sendsmsotp', (params), this._httpOptions());
  }
  
  sendSmsuncoverage(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/sendsmsuncoverage', (params), this._httpOptions());
  }
  
  checkOtpprospek(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/checkotp/'+params.prospekindex, (params), this._httpOptions());
  }

  getIdtype(){
    return this.http.get<any>(this.urlApi + 'apipage/apitocrms/getidtype', this._httpOptions());
  }

  getSubscribetype(){
    return this.http.get<any>(this.urlApi + 'apipage/apitocrms/getsubscribetype', this._httpOptions());
  }

  getHometype(){
    return this.http.get<any>(this.urlApi + 'apipage/apitocrms/gethometype', this._httpOptions());
  }

  getHomestatus(){
    return this.http.get<any>(this.urlApi + 'apipage/apitocrms/gethomestatus', this._httpOptions());
  }

  setProspekdetail(params: any){
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/createprospekdtl/'+ params.prospekindex, (params), this._httpOptions());
  }

  getProduct(){
    return this.http.get<any>(this.urlApi + 'apipage/apitocrms/crmtoprod', this._httpOptions());
  }

  getListgroupproduct(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/listgroupproduct', JSON.stringify(params) , this._httpOptions());
  }

  getAlacarte(params:any){
    return this.http.post<any>(this.urlApi + 'apipage/apitocrms/crmtoprodalacarte', JSON.stringify(params) , this._httpOptions());
  }

  listProductiptvsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/productiptv', params,this._httpOptions());
  }

  listProducthsisgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/producthsi', params,this._httpOptions());
  }

  listProductalacartesgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/productalacarte', params,this._httpOptions());
  }

  listBonusregissgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/bonusregis', params,this._httpOptions());
  }

  listDiscountregissgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/discountregis', params,this._httpOptions());
  }

  setProspekorder(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/createprospekorder/'+ params.prospekindex, (params), this._httpOptions());
  }

  clearBonus(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/clearprospekbonus/'+ params.prospekindex, (params), this._httpOptions());
  }

  setBonus(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/createprospekbonus/'+ params.prospekindex, (params), this._httpOptions());
  }

  clearDiscount(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/clearprospekdiscount/'+ params.prospekindex, (params), this._httpOptions());
  }

  setDiscount(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/createprospekdiscount/'+ params.prospekindex, (params), this._httpOptions());
  }

  setPaymentmethod(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/createprospekbilling/'+ params.prospekindex, (params), this._httpOptions());
  }

  getPembayaran(params: any){
      return this.http.post<any>(this.urlApi + 'apipage/apitocrms/getpembayaran', JSON.stringify(params), this._httpOptions());
  }  

  getProspeksummary(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/prospeksummary/'+ params.prospekindex, params, this._httpOptions());
  }  

  getProspekinfo(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/view/'+ params.prospekindex, params, this._httpOptions());
  }  

  setValidate(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/setvalidate/'+ params.prospekindex, params, this._httpOptions());
  }  

  getProspekinstal(params: any) {
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/getprospekinstl/'+ params.prospekindex, params, this._httpOptions());
  }
  setChangestatus(params: any) {
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/changestatus/'+ params.prospekindex, params, this._httpOptions());
  }
  /* End Regis */

  /* Get Product CRM */
  getProductcrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/productcrm', params,this._httpOptions());
  }
  
  getProductupgradecrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/productupgradecrm', params,this._httpOptions());
  }
  
  setProductupgradecrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/setproductupgradesgs', params,this._httpOptions());
  }

  getBonuscrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/bonuscrm', params,this._httpOptions());
  }

  getDiscountcrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/discountcrm', params,this._httpOptions());
  }

  getAlacartecrm(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/alacartecrm', params, this._httpOptions());
  }
  
  listProductsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/listproduct', params,this._httpOptions());
  }
  
  listBonussgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/listbonus', params,this._httpOptions());
  }

  listDiscountsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/listdiscount', params,this._httpOptions());
  }

  setImageproduct(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/setimageproduct', params,this._httpOptions());
  }

  getListimageproduct(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/listimageproduct', params,this._httpOptions());
  }
  
  getImageproduct(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/getimageproduct', params,this._httpOptions());
  }

  setImageproductdet(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/setimageproductdet', params,this._httpOptions());
  }
  
  getListimgproddtl(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/getlistimgproddet', params,this._httpOptions());
  }
  
  getImageproductdet(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/getimageproductdet', params,this._httpOptions());
  }

  getImageproductbonus(params:any){
    return this.http.post<any>(this.urlApiImage + 'ordermanagement/products/getimageproduct', params,this._httpOptions());
  }

  addProductsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/addproductsgs', params,this._httpOptions());
  }
  
  addAlacartesgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/addalacartesgs', params,this._httpOptions());
  }

  editProductsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/editproductsgs', params,this._httpOptions());
  }

  addBonussgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/addbonussgs', params,this._httpOptions());
  }

  editBonussgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/editbonussgs', params,this._httpOptions());
  }

  addDiscountsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/adddiscountsgs', params,this._httpOptions());
  }

  editDiscountsgs(params:any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/editdiscountsgs', params,this._httpOptions());
  }

  listAlacartesgs(params: any){
    return this.http.post<any>(this.urlApi + 'ordermanagement/products/alacartecrm', params, this._httpOptions());
  }
  /* END Product CRM */

  /* Account */  
  getProvince(params: any){
      return this.http.post<any>(this.urlApi + 'master/provinces/datalist', (params), this._httpOptions());
  }

  getCity(params: any){
      return this.http.post<any>(this.urlApi + 'master/cities/datalist', (params), this._httpOptions());
  }

  getDistrict(params: any){
      return this.http.post<any>(this.urlApi + 'master/districts/datalist', (params), this._httpOptions());
  }

  getSubdistrict(params: any){
      return this.http.post<any>(this.urlApi + 'master/subdistricts/datalist', (params), this._httpOptions());
  }

  getPostalcode(params: any){
      return this.http.post<any>(this.urlApi + 'master/postalcodes/datalist', (params), this._httpOptions());
  }

  getIkrgis(params: any){
      return this.http.post<any>(this.urlApi + 'master/ikrgis/datalist', (params), this._httpOptions());
  }
  
  getRefProvince(params: any){
      return this.http.post<any>(this.urlApi + 'master/provinces/dataref', (params), this._httpOptions());
  }

  getRefCity(params: any){
      return this.http.post<any>(this.urlApi + 'master/cities/dataref', (params), this._httpOptions());
  }

  getRefDistrict(params: any){
      return this.http.post<any>(this.urlApi + 'master/districts/dataref', (params), this._httpOptions());
  }

  getRefSubdistrict(params: any){
      return this.http.post<any>(this.urlApi + 'master/subdistricts/dataref', (params), this._httpOptions());
  }

  getRefRw(params: any){
      return this.http.post<any>(this.urlApi + 'master/subdistricts/datarefrw', (params), this._httpOptions());
  }

  getLocationPosCode(params: any){
      return this.http.post<any>(this.urlApi + 'apipage/apitocrms/getlocationposcode', params, this._httpOptions());
  }
  /* End Account */
  
  
  /* SGS Profile */
  GetSgsprofile(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'subgetsub/accounts/accountinfo', this._httpOptions());
  }
  /* End SGS Profile */

  /* Prospect */
  GetSgsprospect(params:any): Observable<any>
  {
    // return this.http.get<any>(this.urlApi + 'subgetsub/prospeks', this._httpOptions() );
    return this.http.get<any>(this.urlApi + 'subgetsub/prospeks', this._httpOptionsparams(params) );
  }
  SearchProspek(data: any){
    // console.log(JSON.stringify(data));
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/search', JSON.stringify(data), this._httpOptions() );
  }
  /* End Prospect */

  /* Admin Profile */
  GetAdminprofile(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/userdetail', this._httpOptions());
  }
  getSalesdetail(id:any): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/salesdetail/'+id, this._httpOptions());
  }
  getListuser(data:any): Observable<any>
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/listuser',JSON.stringify(data), this._httpOptions());
  }
  getListusersales(data:any): Observable<any>
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/listusersales',JSON.stringify(data), this._httpOptions());
  }
  getListregion(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/listregion', this._httpOptions());
  }
  getListstatus(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/liststatus', this._httpOptions());
  }
  getListpartner(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/listpartner', this._httpOptions());
  }
  getListrole(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/listrole', this._httpOptions());
  }
  getListsaleslv(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/listsaleslv', this._httpOptions());
  }
  getListleader(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/listleader',JSON.stringify(data), this._httpOptions());
  }
  checksalescode(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checksalescode',JSON.stringify(data), this._httpOptions());
  }
  checkemail(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checkemail',JSON.stringify(data), this._httpOptions());
  }
  checknik(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checknik',JSON.stringify(data), this._httpOptions());
  }
  checkusername(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checkusername',JSON.stringify(data), this._httpOptions());
  }
  createuser(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/createuser',JSON.stringify(data), this._httpOptions());
  }
  createuserbulk(data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/createuserbulk',JSON.stringify(data), this._httpOptions());
  }
  updateuser(id:any, data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/updateuser/'+id,JSON.stringify(data), this._httpOptions());
  }
  resetuser(id:any, data:any)
  {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/resetuser/'+id,JSON.stringify(data), this._httpOptions());
  }
  templateuser()
  {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/templateuser', this._httpOptions());
  }
  /* End Admin Profile */

  /* Member SGS */
  checkref(data:any)
  {
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/checkref',JSON.stringify(data), this._httpOptions());
  }
  /* End Member SGS */

  /* Admin Report */
  GetAdminreport(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'subgetsub/prospeks/reporting', this._httpOptions() );
  }
  /* End Admin Report */

  /* Admin Customer */
  Admincustomer(){
    return this.http.post<any>(this.urlApi + 'apipage/apitocrms/crmtocustomer', JSON.stringify({}), this._httpOptions() );
  }
  loadAdmincustomer(){
    return this.http.get<any>(this.urlApi + 'subgetsub/customers', this._httpOptions() );
  }
  searchCustomer(data: any){
    return this.http.post<any>(this.urlApi + 'subgetsub/customers/search', JSON.stringify(data), this._httpOptions() );
  }
  getMapGeojson(data: any){
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/getkml', data, this._httpOptions() );
  }
  /* End Admin Customer */

  /* Admin Product */

  getMenu(){
    const params: any = {};

    return this.http.get<any>(this.urlApi + 'apis/menu', this._httpOptionsparams(params));
  }

  // get type
  getSgshomestatus(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'master/thetypes/homestatus', this._httpOptions());
  }
  getSgshometype(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'master/thetypes/hometype', this._httpOptions());
  }
  getSgstypeidentity(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'master/thetypes/typeidentity', this._httpOptions());
  }
  getSgstyperelative(): Observable<any>
  {
    return this.http.get<any>(this.urlApi + 'master/thetypes/typerelative', this._httpOptions());
  }

  uploadtest(params: any){
    return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/uploadtest', JSON.stringify(params), this._httpOptions());
}
}
